import * as React from "react";
import {AuthMeModel} from "../models/auth-me.model";
import {RootState} from "../store/root-reducer";
import {AccountTypeEnum} from "../models/account-type.enum";
import AuthorDashboard from "../components/author/dashboard";
import {useSelector} from "react-redux";
import PublisherDashboard from "../components/publisher/dashboard";

const DashboardPage = () => {
    const authMe: AuthMeModel = useSelector(
        (state: RootState) => state.auth.user
    );

    return (
        <>
            {authMe && authMe.account_type === AccountTypeEnum.AUT &&
                <AuthorDashboard/>
            }
            { authMe && authMe.account_type === AccountTypeEnum.PUB &&
                <PublisherDashboard/>
            }
        </>
    )
};

export default DashboardPage;
